import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import cn from 'classnames';
import { useCallback } from 'react';
import { useSelector } from 'react-redux';
import CancelIcon from '../CancelIcon/CancelIcon';
import styles from './Modal.module.scss';
const Modal = ({ children, closeModal, className, wrapClassName, isFocus, overlay = true, background, isStatic }) => {
    const darkMode = useSelector((state) => state.settings.darkMode);
    const onModalClose = useCallback(() => {
        if (!isStatic) {
            closeModal && closeModal();
        }
    }, [isStatic, closeModal]);
    return (_jsxs("div", Object.assign({ className: cn(styles.element, isFocus && styles.focus) }, { children: [overlay && (_jsx("div", { "data-testid": "cancelIcon", className: styles.overlay, onClick: onModalClose })), _jsxs("div", Object.assign({ className: cn(className, styles.content, wrapClassName, background && styles['isBackground'], darkMode && styles['isDarkMode']) }, { children: [children, !isStatic && _jsx(CancelIcon, { "data-testid": "cancelIcon", onClick: onModalClose })] }))] })));
};
export default Modal;
